(ns ncr.scratch
  (:require
   [ncr.widgets.core :as w]
   [ncr.etc.pf :as pf]
   [ncr.etc.profile-pspec :as p]
   [ncr.scratch.general]
   [ncr.scratch.pf]))

(def tabs
  [{:id "PatternFly" :component ncr.scratch.pf/c-component}
   {:id "General" :component ncr.scratch.general/c-component}])

(defn c-scratch [_]
  (let [selected (p/use-scratch-selected "General")]
    [w/c-error-boundary
     [pf/c-page-section {:class-name :ncr-c-scratch}
      (into
        [pf/c-tabs
         {:active-key @selected
          :on-select
          (fn [_ key]
            (reset! selected key))}]

        (map
          (fn [{:keys [id component]}]
            [pf/c-tab
             {:title [pf/c-tab-title-text id]
              :event-key id}
             [component]])
          tabs))]]))